import { render, staticRenderFns } from "./SideMenuBar.vue?vue&type=template&id=58a7d5d8&"
import script from "./SideMenuBar.vue?vue&type=script&lang=ts&"
export * from "./SideMenuBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports